import { NumericStepperField } from '@/forms-legacy'

import { useTexts } from '../hooks/useTexts'

const wrappedInputProps = {
  step: 5,
  min: 0,
}

export function MaxOrders() {
  const texts = useTexts()

  return (
    <NumericStepperField
      name="maxOrders"
      testid="maxOrders"
      half
      label={texts.maxOrders}
      wrappedInputProps={wrappedInputProps}
    />
  )
}
